// extracted by mini-css-extract-plugin
export var optionGrid = "_5p-7";
export var optionList = "_5p-6";
export var questionsBlock = "_5p-9";
export var spacer = "_5p-5";
export var stepCenteredContent = "_5p-3";
export var stepInner = "_5p-0";
export var stepInnerFullWidth = "_5p-1";
export var stepInnerLockScroll = "_5p-2";
export var stepTransitionFrame = "_5p-4";
export var welcomeBlock = "_5p-8";